module.exports = __webpack_public_path__ + "img/flowb.158ead20.jpg";